import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserDetails } from '../../../../actions/auth';
import { Box, Button, Divider, Grid } from '@mui/material';
import RofBatchVolume from './data-tables/RofBatchVolume';
import RofBatchBulkDensity from './data-tables/RofBulkDensity';
import RofBiocharMass from './data-tables/RofBiocharMass';
import RofBiocharLabSamples from './data-tables/RofBiocharLabSamples';
import RofContaminants from './data-tables/RofContaminants';
import RofFuel from './data-tables/RofFuel';
import RofEquipmentTransport from './data-tables/RofEquipmentTransport';
import {
    getBiocharLabSamples,
    getBiocharLabSamplesContaminants,
    getEquipmentTransport,
    getIgnitionFuel,
    getRofBurnsBatchBulkDensity,
    getRofBurnsBatchVolumes,
    getRofBurnsBiocharMass
} from '../../../../actions/rof-burns/rof-actions';


export default function RofDataTables() {
    const [selectedCategory, setSelectedCategory] = useState('Batch Volumes');
    const [selectedSubCategory, setSelectedSubCategory] = useState('');
    const batchVolumes = useSelector(state => state.rofBurnsReducer.batchVolumes)
    const batchBulkDensity = useSelector(state => state.rofBurnsReducer.bulkDensity)
    const biocharMass = useSelector(state => state.rofBurnsReducer.biocharMass)
    const biocharLabSamples = useSelector(state => state.rofBurnsReducer.biocharLabSamples)
    const biocharLabSamplesContaminants = useSelector(state => state.rofBurnsReducer.biocharLabSamplesContaminants)
    const ignitionFuel = useSelector(state => state.rofBurnsReducer.ignitionFuel);
    const equipmentTransport = useSelector(state => state.rofBurnsReducer.equipmentTransport);

    const { selectedProject } = useSelector(state => state.postFormData);
    const { id } = selectedProject || {} //measureType
    const dispatch = useDispatch();

    const DATA_TABLE_CATEGORIES = [
        'Batch Volumes',
        'Batch Bulk Density',
        'Biochar Mass',
        'Lab Tests & Factors',
        'Fuel',
        'Equipment Transport'
    ]

    const DATA_TABLE_SUB_CATEGORIES = {
        'Lab Tests & Factors': ['C_ORG & H:C Samples', 'Contaminants']
    }

    const handleSelectCategory = (category) => {
        setSelectedCategory(category);
        setSelectedSubCategory(DATA_TABLE_SUB_CATEGORIES[category]?.[0] || '');
    }

    useEffect(() => {
        dispatch(getUserDetails());
        if (selectedCategory === 'Batch Volumes')
            dispatch(getRofBurnsBatchVolumes(id));
        else if (selectedCategory === 'Batch Bulk Density')
            dispatch(getRofBurnsBatchBulkDensity(id));
        else if (selectedCategory === 'Biochar Mass')
            dispatch(getRofBurnsBiocharMass(id))
        else if (selectedSubCategory === 'C_ORG & H:C Samples')
            dispatch(getBiocharLabSamples(id))
        else if (selectedSubCategory === 'Contaminants')
            dispatch(getBiocharLabSamplesContaminants(id))
        else if (selectedCategory === 'Fuel')
            dispatch(getIgnitionFuel(id))
        else if (selectedCategory === 'Equipment Transport')
            dispatch(getEquipmentTransport(id))
    }, [dispatch, selectedCategory, selectedSubCategory, id]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Grid item xs={12} sx={{ display: 'flex', gap: 2 }}>
                {DATA_TABLE_CATEGORIES.map((category, index) => (
                    <Button
                        key={index}
                        onClick={() => handleSelectCategory(category)}
                        variant={category === selectedCategory ? 'contained' : 'outlined'}
                    >
                        {category}
                    </Button>
                ))}
            </Grid>
            {DATA_TABLE_SUB_CATEGORIES[selectedCategory] &&
                <Grid item xs={12} sx={{ display: 'flex', gap: 2 }}>
                    {DATA_TABLE_SUB_CATEGORIES[selectedCategory].map((subCategory, index) => (
                        <Button
                            key={index}
                            onClick={() => setSelectedSubCategory(subCategory)}
                            variant={subCategory === selectedSubCategory ? 'contained' : 'text'}
                        >
                            {subCategory}
                        </Button>
                    ))}
                </Grid>
            }
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Box sx={{ display: 'flex', flexDirection: 'column', px: 2 }}>
                {selectedCategory === 'Batch Volumes' &&
                    <RofBatchVolume batchVolumes={batchVolumes} selectedProject={selectedProject} />
                }
                {selectedCategory === 'Batch Bulk Density' &&
                    <RofBatchBulkDensity batchBulkDensity={batchBulkDensity} selectedProject={selectedProject} />
                }
                {selectedCategory === 'Biochar Mass' &&
                    <RofBiocharMass biocharMass={biocharMass} selectedProject={selectedProject} />
                }
                {selectedCategory === 'Lab Tests & Factors' && selectedSubCategory === 'C_ORG & H:C Samples' &&
                    <RofBiocharLabSamples biocharLabSamples={biocharLabSamples} selectedProject={selectedProject} />
                }
                {selectedCategory === 'Lab Tests & Factors' && selectedSubCategory === 'Contaminants' &&
                    <RofContaminants contaminants={biocharLabSamplesContaminants} selectedProject={selectedProject} />
                }
                {selectedCategory === 'Fuel' &&
                    <RofFuel fuel={ignitionFuel} selectedProject={selectedProject} />
                }
                {selectedCategory === 'Equipment Transport' &&
                    <RofEquipmentTransport equipmentTransport={equipmentTransport} selectedProject={selectedProject} />
                }
            </Box>
        </Box>
    )
}